import { httpClient } from '@bcba/client-auth';
import { ProvinceSerializer } from '@bcba/serializers';

const basePath = '/provinces/';

export const getProvinces = async (): Promise<ProvinceSerializer[]> => {
  const { data } = await httpClient.get<ProvinceSerializer[]>(basePath);

  return data;
};
